<template>
  <v-container class fluid>
    <!-- <v-row>
      <v-col class="d-flex" cols="12" sm="4" offset-md="7">
        <v-select :items="getDashboardDateHorizon" label="Date horizon" dense></v-select>
      </v-col>
    </v-row>-->
    <v-row>
      <v-col cols="12" lg="6" xl="4">
        <turnover-month></turnover-month>
      </v-col>
      <v-col cols="12" lg="6" xl="4">
        <hours-month></hours-month>
      </v-col>
      <v-col cols="12" lg="6" xl="4">
        <turnover-area></turnover-area>
      </v-col>
      <v-col cols="12" lg="6" xl="4">
        <expenses-month></expenses-month>
      </v-col>
    </v-row>
    <v-row dense>
      <!-- <v-col cols="12">
        <free-chart></free-chart>
      </v-col>-->
      <!-- <v-col cols="12" sm="6" md="4">
        <turnover-month></turnover-month>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <hours-month></hours-month>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <turnover-area></turnover-area>
      </v-col>-->
    </v-row>
  </v-container>
</template>

<script>
import { db } from "../auth";
import { storeprops } from "../store/helpers.js";
import TurnoverMonth from "@/components/dashboard/TurnoverMonth";
import TurnoverArea from "@/components/dashboard/TurnoverArea";
import HoursMonth from "@/components/dashboard/HoursMonth";
import FreeChart from "@/components/dashboard/FreeChart";
import ExpensesMonth from "@/components/dashboard/ExpensesMonth";

export default {
  components: {
    TurnoverMonth,
    TurnoverArea,
    HoursMonth,
    ExpensesMonth,
    FreeChart,
  },
  props: {
    source: String,
  },
  data: () => ({
    // value: [423, 446, 675, 510, 590, 610, 760],
    // dbDuration: undefined,
    // items: ["Foo", "Bar", "Fizz", "Buzz"]
  }),
  computed: {
    ...storeprops,
  },
  methods: {},
  mounted() {
    //debugger;
    // const { currentUser } = firebase.auth();
    // this.user = currentUser;
    // A bigger, more impactful business
  },
};
</script>